import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import roles from '../SecuredArea/roles';
import excludeCases from '../SecuredArea/excludeCases';
import { resetSubMenu } from '../reducers/subMenuActions';
import { selectAuth } from '../store/selectors/auth';
import { selectUserInfo } from '../store/selectors/userInfo';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';

export default function withRestrictedAccess(WrappedComponent) {
  const Wrapper = (props) => {
    const authReducer = useSelector(selectAuth);
    const userInfo = useSelector(selectUserInfo);
    const { formatMessage } = useIntl();

    let error = '';
    if (authReducer.authenticated && !authReducer.roles.includes(roles[props.match.path])) {
      error = formatMessage({
        id: 'Access denied for given resource',
      });
    }
    if (authReducer.authenticated && userInfo.data && userInfo.data?.status === excludeCases[props.match.path]) {
      error = formatMessage({
        id: 'Access denied for given resource',
      });
    }
    if (error) {
      props.dispatch(resetSubMenu());
    }
    return (
      <div>
        {authReducer.authenticated && authReducer.roles.includes(roles[props.match.path]) && (
          /* eslint-disable-next-line react/jsx-props-no-spreading */
          <WrappedComponent {...props} />
        )}
        {!authReducer.authenticated && <Redirect to={{ pathname: '/login', state: { error } }} />}
        {authReducer.authenticated && !authReducer.roles.includes(roles[props.match.path]) && <Redirect to='/403' />}{' '}
        {authReducer.authenticated && userInfo.data && userInfo.data?.status === excludeCases[props.match.path] && <Redirect to='/403' />}
      </div>
    );
  };

  Wrapper.propTypes = {
    authReducer: PropTypes.shape({
      authenticated: PropTypes.bool.isRequired,
      /* eslint-disable-next-line react/forbid-prop-types */
      roles: PropTypes.array.isRequired,
    }),
    /* eslint-disable-next-line react/forbid-prop-types */
    match: PropTypes.object.isRequired,
    /* eslint-disable-next-line react/forbid-prop-types */
    intl: PropTypes.object.isRequired,
  };

  return Wrapper;
}
